import { set } from './';
/**
 * Like Object.assign, but property names can be dot-notated, e.g.
 *
 *
 *     assignDot({}, {
 *        'foo.bar': 123,
 *        'fizz.baz.buz': 'foobar'
 *     })
 *
 * .. will map the dot-notated property names to a real object structure.
 *
 * @param {object} target The target to assign to
 * @param {any} sources One or more source objects, with dot-notated properties
 * @returns {object} the target
 * @memberof objects
 */
export default function assignDot(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            set(target, key, obj[key]);
        });
    });
    return target;
}
//# sourceMappingURL=assign-dot.js.map